import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';

import { apps } from '../../../constants';
import { DatePickerLocale } from '../../../models';
import { DebugLoggerService } from '../../../services/debug-logger.service';
import { AppStateHolder } from '../../../shared';
import { LastUsedService } from './crm-lastUsed.service';

@Component({
  selector: 'crm-last-parties',
  templateUrl: 'crm-lastUsed.component.html',
  styleUrls: ['./crm-lastUsed.component.scss'],
  standalone: true,
  imports: [TranslateModule]
})
export class LastPartiesComponent implements OnInit, OnDestroy {
  private toastrService = inject(ToastrService);
  private translator = inject(TranslateService);
  private service = inject(LastUsedService);
  private primeConfig = inject(PrimeNGConfig);
  private router = inject(Router);
  appStateHolder = inject(AppStateHolder);
  private _debugLogger = inject(DebugLoggerService);

  @Input() modify: Boolean = false;
  @Input() border: boolean;
  @Input() widgetPosition: any;

  requestsSubscribe: Subscription;

  visitedParties: any[];
  errorDisplay: boolean = false;
  errorMessage: string;

  // Proprietà per gestire il caricamento
  isLoading: boolean = true;

  ngOnInit(): void {
    this._debugLogger.logLifecycle('LastParties', 'ngOnInit');
    this.translator.setDefaultLang('it');
    this.primeConfig.setTranslation(DatePickerLocale.it);

    this.isLoading = true;

    if (this.modify) {
      this.isLoading = false;
      this.visitedParties = [];
    } else {
      this.requestsSubscribe = this.service
        .getVisited()
        .subscribe(
          result => {
            this._debugLogger.logAction('LastParties', 'visited parties loaded', { count: result?.length });
            this.visitedParties = result;
            this.isLoading = false;
          },
          error => {
            this.isLoading = false;

            if (error === '400 - Bad Request') {
              this.toastrService.error(this.translator.instant('app.unexpectedError'));
            } else {
              this.toastrService.error(error);
            }
          }
        );
    }
  }

  errorClose() {
    this.errorDisplay = false;
    this.errorMessage = '';
  }

  onSelectParty(party) {
    this._debugLogger.logAction('LastParties', 'selectParty', { id: party?.id });
    if (party === undefined)
      return;

    let url = this.appStateHolder.getAppUrl(apps.crm);
    this.appStateHolder.setAppNavbarClass(apps.crm);

    if (url.length === 0) {
      let link = ['/console', party.id];
      this._debugLogger.logNavigation(link.join('/'));
      this.router.navigate(link)
      return;
    }

    let link = ['/app', `${url}/console/${party.id}`];
    this._debugLogger.logNavigation(link.join('/'));
    this.router.navigate(link);
  }

  hasDatas(): Boolean {
    if (!this.visitedParties) {
      return false;
    }
    return (this.visitedParties.length > 0);
  }

  ngOnDestroy(): void {
    if (this.requestsSubscribe) {
      this.requestsSubscribe.unsubscribe();
    }
  }
}
